import {createContext} from "react";

import type {IApiEndpoint, IApiResponse, IPagination} from "../sitemap/apiendponts.ts";

export interface fetchOptions<T> {
	endpoint: IApiEndpoint<T>,
	query?: object,
	pagination?: IPagination,
	signal?: AbortSignal
}

type ApiContextType = {
	fetchData: <T>(options: fetchOptions<T>, ignoreCache?: boolean) => Promise<IApiResponse<T>>
}

export const ApiContext = createContext<ApiContextType | null>(null)